import React, { useEffect, useState } from "react";
import { usePermission } from "../../../hooks/usePermission";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Col,
  message,
  Popconfirm,
  Row,
  Space,
  Table,
  notification,
  Tooltip,
  Switch,
  Modal,
  Input,
  Form,
} from "antd";
import { UserFilters } from "./UserFilters";
import { SearchOutlined } from "@ant-design/icons";
import IMAGES from "../../../const/Image";
import Search from "antd/es/input/Search";
import { FaSliders } from "react-icons/fa6";
import { components, getRowClassName } from "../../../utils/utils";
import staffRequest from "../StaffRequest";
import RoleRequest from "../Role/RoleRequest";
const { confirm } = Modal;
const initialFilter = {
  page: 1,
};

export const Users = () => {
  const hasListPermission = usePermission("Users", "List");
  // console.log('Has list permission:', hasListPermission);
  const hasAddPermission = usePermission("Users", "Add");
  const hasEditPermission = usePermission("Users", "Edit");
  const hasDeletePermission = usePermission("Users", "Delete");
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [labList, setLabList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [roleDetails, setRoleDetails] = useState();
  const [filterForm, setFilterForm] = useState({});
  const [filter, setFilter] = useState(initialFilter);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  const showConfirm = Modal.confirm;
  console.log(roleDetails, "role");

  const fetchStaffList = () => {
    setLoading(true);
    staffRequest
      .getStaffList(filter)
      .then((response) => {
        const rawData = response?.data?.data?.data || [];
        console.log(rawData);
        const totalCount = response?.data?.total || 0;
        setLabList(rawData);
        setFilteredUsers(rawData);
        setTotalRecords(totalCount);
      })
      .catch((error) => {
        message.error("Failed to fetch users.");
        console.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (hasListPermission) {
      fetchStaffList();
    }
  }, [filter, hasListPermission]);

  const handleFilter = (value) => {
    setFilter({ ...filter, ...filterForm, ...initialFilter });
    console.log("filter", filter);
    setIsModalOpen(false);
  };

  const handleChange = (pagination) => {
    setFilter({
      ...filter,
      page: pagination?.current,
    });
  };

  const resetFilters = () => {
    form.resetFields();
    setFilterForm({});
    setFilter(initialFilter);
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const columns = (navigate) => [
    {
      title: "S No.",
      dataIndex: "sno",
      key: "sno",
      render: (value, item, index) => (filter?.page - 1) * 10 + index + 1,
    },
    {
      title: "User Id",
      dataIndex: "staffId",
      key: "staffId",
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Phone",
      dataIndex: "mobile",
      key: "mobile",
    },
    {
      title: "Role",
      dataIndex: "roleTitle",
      key: "roleTitle",
      render: (role) => role,
    },
    {
      title: "Status",
      dataIndex: "status",
      width: 120,
      align: "center",
      render: (is_active, item) => (
        <Switch
          checked={is_active === 1}
          checkedChildren="Active"
          unCheckedChildren="Inactive"
          onChange={(checked) => handleStatusChange(checked, item)}
        />
      ),
    },

    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
             {hasEditPermission && (
          <Tooltip title="Edit Details">
            <span
              className="action-icon-bg"
              onClick={() =>
                navigate(`/user-management/users/update/${record.staffId}`)
              }
            >
              <img src={IMAGES.EditIcon} />
            </span>
          </Tooltip>
             )}

                {hasDeletePermission && (
          <Popconfirm
            title="Delete the task"
            description="Are you sure to delete this task?"
            onConfirm={() => handleDelete(record.staffId)}
            okText="Yes"
            cancelText="No"
          >
            <span className="action-icon-bg">
              <img src={IMAGES.DeleteIcon} alt="" />
            </span>
          </Popconfirm>
                )}
                
        </Space>
      ),
    },
    // Add other columns as needed
  ];

  const handleStatusChange = (checked, item) => {
    if (!item.staffId) {
      notification.error({
        message: "User ID is required to update status.",
      });
      return;
    }
    showConfirm({
      title: `Are you sure you want to ${
        checked ? "activate" : "deactivate"
      } this user?`,
      okText: "Yes",
      cancelText: "No",
      onOk() {
        setLoading(true);
        staffRequest
          .updateStaff({
            status: checked ? 1 : 0,
            staffId: item.staffId,
          })
          .then((res) => {
            if (res && res.status === 200) {
              notification.success({
                message: "User updated successfully",
              });
              fetchStaffList();
            } else {
              notification.error({
                message: "Failed to update status",
              });
            }
          })
          .catch(() => {
            notification.error({
              message: "Failed to update status",
            });
          })
          .finally(() => {
            setLoading(false);
          });
      },
    });
  };

  const handleDelete = (staffId) => {
      if (!hasDeletePermission) {
          notification.error({
            message: "You don't have permission to delete coupons",
          });
          return;
        }

    setLoading(true);
    staffRequest
      .deleteStaff(staffId)
      .then(() => {
        message.success("User deleted successfully");
        fetchStaffList();
      })

      .catch((error) => {
        message.error("Failed to delete user");
        console.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <div className="">
        <Row gutter={[8, 8]} justify="space-between" align="middle">
          <Col>
            <h1 className="app-heading-med">Users List</h1>
          </Col>

          <Col>
            <div style={{ display: "flex", gap: "1rem" }}>
              <Input
                placeholder="Search..."
                size="large"
                className="FilterSearchBox"
                onChange={(e) =>
                  setFilterForm({ ...filterForm, search: e.target.value })
                }
                value={filterForm?.search}
                style={{ width: "100%" }}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    handleFilter();
                  }
                }}
              />
              <Button
                onClick={handleFilter}
                type="primary"
                htmlType="submit"
                className="addcity-btn"
                style={{ height: "39px" }}
              >
                <SearchOutlined />
              </Button>
              <Button
                onClick={() => showModal()}
                type="primary"
                htmlType="submit"
                className="addcity-btn"
                style={{ height: "39px" }}
              >
                <FaSliders />
              </Button>
              <Button
                type="primary"
                className="addcity-btn"
                onClick={resetFilters}
                style={{ height: "39px" }}
              >
                Reset
              </Button>

                 {hasAddPermission && (
              <Button
                onClick={() => navigate("/user-management/user/add")}
                type="primary"
                className="addcity-btn"
                style={{ height: "39px" }}
              >
                <img src={IMAGES.AddIconFilters} alt="Add" />
              </Button>
                 )}

            </div>
          </Col>
        </Row>
      </div>
      <div style={{ marginTop: "20px" }}>
        <Table
          size="middle"
          bordered
          rowClassName={getRowClassName}
          components={components}
          columns={columns(navigate)}
          loading={loading}
          onChange={handleChange}
          dataSource={filteredUsers}
          pagination={{
            total: totalRecords,
            current: filter?.page || 0,
            defaultCurrent: 1,
          }}
        />
      </div>
      <UserFilters
        handleFilter={handleFilter}
        form={form}
        filterForm={filterForm}
        setFilterForm={setFilterForm}
        isModalOpen={isModalOpen}
        handleCancel={handleCancel}
      />
    </>
  );
};
